// extracted by mini-css-extract-plugin
module.exports = {"linksContainer":"Trucks_linksContainer__ixJcd","addTruck":"Trucks_addTruck__neGUQ"};